import store from "@/store/store";

export default {
    SET_CHAT_TICKET_COSTS(state, ticketCosts) {
        state.chatTicketCosts = ticketCosts;
    },
    SET_COSTS_BY_TYPES(state, ticketCosts){
        state.sumTypeCosts = ticketCosts;
    },
    SET_CHAT_TICKET_COSTS_BY_TYPES(state, { type, collumn }){
        for( let key in state[type] ) {
            state[key] = state.chatTicketCosts.filter((elem) => {
                return elem[collumn] === state[type][key]
            });
        }
    }
}
